// @ts-strict-ignore
import clsx from 'clsx'
import { FC } from 'react'

import { useToggle } from '@/shared/lib/hooks/useToggle'
import { Button } from '@/shared/ui'

import { gridNoteProps } from '../styles'

import cl from './NodeList.module.scss'

export const NoteList: FC<{ data: gridNoteProps[] }> = ({ data }) => {
	const [isActive, setIsActive] = useToggle(false)
	const buttonText = isActive ? 'Скрыть' : 'Подробнее'
	const styleContainer = isActive ? clsx(cl.noteContainer) : clsx(cl.noteContainer, cl.noteContainer_close)
	return (
		<>
			<div className={styleContainer}>
				{data.map((item, index) => (
					<div key={index + 'col'} className={cl.collapse}>
						<h4 className={cl.title}>{item.title}</h4>
						<ul className={cl.list}>
							{item.list.map((item, index) => (
								<li key={index + 'row'} className={cl.noteItem}>
									<p className={cl.text}>{item}</p>
								</li>
							))}
						</ul>
					</div>
				))}
			</div>
			<Button theme={'link'} className={cl.btn} onClick={setIsActive}>
				{buttonText}
			</Button>
		</>
	)
}
